/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'file-object';

export const fileObjectModalBreadcrumbTitle = `${prefix}.fileObjectModalBreadcrumbTitle`;

export const ENGLISH = {
    [fileObjectModalBreadcrumbTitle]: 'File Object',
};
